// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__xrVnQ","breadcrumb":"Breadcrumbs_breadcrumb__nXx7p"};